import {
  GET_AUDIENCE_CARD_DATA,
  GET_BRAND_OVERVIEW_CARDS_DATA,
  GET_BRAND_RADAR_POSTS,
  GET_FAVORITE_TERRITORIES_TOTAL,
  GET_PLATFORM_DISTRIBUTION,
  GET_TERRITORIES_RELEVANCE,
  GET_TERRITORY_FOR_TABLE,
  GET_TERRITORY_AUTOMATIC_DESCRIPTION,
  GET_TERRITORY_POSTS_SEARCH,
  GET_TERRITORY_POSTS_PERFORMANCE,
  LIST_TERRITORIES_WITH_METRICS,
  MANAGE_TERRITORY_FAVORITE_MUTATION,
  GET_TERRITORY_DESCRIPTION,
  GET_TERRITORY_TITLE,
  GET_SCOPE_TERRITORY,
  GET_OWNED_TOPICS,
  GET_UNIFIED_TERRITORIES,
  GET_BASIC_TERRITORIES_LIST,
  GET_FAVORITE_TERRITORIES,
  GET_TERRITORIES_VIEWS_OVER_TIME,
  GET_TERRITORY_SAVED_POST_SEARCH_TOTAL_POST_BY_ID,
  GET_TERRITORY_NICHES_BRANDED_VS_UGC,
  CREATE_OWNED_TOPIC,
  TERRITORY_PERFORMANCE_TAB_QUERY,
  GET_TERRITORY_CREATORS,
} from './operations'
import type { TTerritoryMutationsMap, TTerritoryQueriesMap } from './types'
export type { TTerritoryCreator } from './types'
export const GRAPHQL_TERRITORY_QUERIES: TTerritoryQueriesMap = {
  getFavoritesTerritoriesTotal: GET_FAVORITE_TERRITORIES_TOTAL,
  GET_TERRITORY_FOR_TABLE,
  getTerritoryAutomaticDescription: GET_TERRITORY_AUTOMATIC_DESCRIPTION,
  getTerritoryPostsSearch: GET_TERRITORY_POSTS_SEARCH,
  getTerritoryPostsPerformance: GET_TERRITORY_POSTS_PERFORMANCE,
  getPlatformDistribution: GET_PLATFORM_DISTRIBUTION,
  getAudienceCardData: GET_AUDIENCE_CARD_DATA,
  getTerritoryDescription: GET_TERRITORY_DESCRIPTION,
  getTerritoryTitle: GET_TERRITORY_TITLE,
  getScopeTerritory: GET_SCOPE_TERRITORY,
  getTerritoriesRelevance: GET_TERRITORIES_RELEVANCE,
  getBrandOverviewCardsData: GET_BRAND_OVERVIEW_CARDS_DATA,
  listTerritoriesWithMetrics: LIST_TERRITORIES_WITH_METRICS,
  getBrandRadarPosts: GET_BRAND_RADAR_POSTS,
  getOwnedTopics: GET_OWNED_TOPICS,
  getUnifiedTerritories: GET_UNIFIED_TERRITORIES,
  getBasicTerritoriesList: GET_BASIC_TERRITORIES_LIST,
  getFavoriteTerritories: GET_FAVORITE_TERRITORIES,
  getTerritoriesViewsOverTime: GET_TERRITORIES_VIEWS_OVER_TIME,
  getTerritorySavedPostTotalPostById: GET_TERRITORY_SAVED_POST_SEARCH_TOTAL_POST_BY_ID,
  territoryPerformanceTabQuery: TERRITORY_PERFORMANCE_TAB_QUERY,
  getTerritoryNichesBrandedVsUgc: GET_TERRITORY_NICHES_BRANDED_VS_UGC,
  getTerritoryCreators: GET_TERRITORY_CREATORS,
}
export const GRAPHQL_TERRITORY_MUTATIONS: TTerritoryMutationsMap = {
  favoriteTerritory: MANAGE_TERRITORY_FAVORITE_MUTATION,
  CREATE_OWNED_TOPIC,
}
